module.exports = __webpack_public_path__ + "static/img/service_content6_img.cb3fed5.png";